/* export const setAccessToken = (token) => {
  document.cookie = `apiToken=${token}`;
};
export const removeAccessToken = () => {
  document.cookie = "apiToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
}; */

import { ltUserKey } from "../environments/environment";

export const setAccessToken = (user) => {
  localStorage.setItem(ltUserKey, JSON.stringify(user));
};
export const getAccessToken = () => JSON.parse(localStorage.getItem(ltUserKey));
export const removeAccessToken = () => {
  localStorage.removeItem(ltUserKey);
};

export const getCookie = (cookieName) => {
  var name = cookieName + "=";
  var allCookieArray = document.cookie.split(";");
  for (var i = 0; i < allCookieArray.length; i++) {
    var temp = allCookieArray[i].trim();
    if (temp.indexOf(name) == 0)
      return temp.substring(name.length, temp.length);
  }
  return "";
};

export const formatDate = (date) => {
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  let current_datetime = new Date(date);
  let formatted_date =
    current_datetime.getDate() +
    "-" +
    months[current_datetime.getMonth()] +
    "-" +
    current_datetime.getFullYear();
  return formatted_date;
};

export const formatDateFromTimeStamp = (timestamp) => {
  // unix timestamp
  let ts = timestamp;

  // convert unix timestamp to milliseconds
  let ts_ms = ts * 1000;

  // initialize new Date object
  let date_ob = new Date(ts_ms);

  // year as 4 digits (YYYY)
  let year = date_ob.getFullYear();

  // month as 2 digits (MM)
  let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);

  // date as 2 digits (DD)
  let date = ("0" + date_ob.getDate()).slice(-2);

  // hours as 2 digits (hh)
  let hours = ("0" + date_ob.getHours()).slice(-2);

  // minutes as 2 digits (mm)
  let minutes = ("0" + date_ob.getMinutes()).slice(-2);

  // seconds as 2 digits (ss)
  let seconds = ("0" + date_ob.getSeconds()).slice(-2);

  let gottenDate = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  let current_datetime = new Date(gottenDate);
  let formatted_date =
    current_datetime.getDate() +
    "-" +
    months[current_datetime.getMonth()] +
    "-" +
    current_datetime.getFullYear();
  return formatted_date;
};

export const isFutureDate = (comingdate) => {
  let currentDate = new Date();
   let date = new Date(comingdate);

   let currentDateTime = currentDate.getTime();
   let dateTime = date.getTime();

   if(currentDateTime < dateTime) {
    return true
   } else {
      return false
   }
 }
